import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import swal from 'sweetalert'

// Components
import Preloader from '../preloader/Preloader'
import { BreadCrumb, Card } from 'src/components'

// Services
import { getProductSingle, createProducts, updateProducts } from 'src/services'

const CreateOrUpdate = () => {
  // Router
  const history = useHistory()
  const { id } = useParams()
  const isUpdating = !!id

  // Local state
  const [loading, setLoading] = useState(isUpdating)
  const [productList, setProductList] = useState({
    product_name: '',
    product_code: '',
    is_customer_product: 0, // Add this property so we can store checkbox state
    error_list: [],
  })

  // Fetch product data if "Update"
  useEffect(() => {
    if (!isUpdating) return

    const loadProduct = async () => {
      try {
        const res = await getProductSingle(id)
        if (res.data.status === 200) {
          setProductList(res.data.product)
        } else {
          history.push('/products')
        }
      } catch (error) {
        history.push('/products')
      } finally {
        setLoading(false)
      }
    }

    loadProduct()
  }, [id, isUpdating, history])

  // Handle text inputs
  const handleInput = (e) => {
    const { name, value } = e.target
    setProductList((prev) => ({ ...prev, [name]: value }))
  }

  // Handle checkbox
  const handleCheckbox = (e) => {
    const { name, checked } = e.target
    setProductList((prev) => ({ ...prev, [name]: checked ? 1 : 0 }))
  }

  // Form submission
  const submitForm = async (e) => {
    e.preventDefault()

    console.log(productList)

    try {
      const data = productList
      const res = isUpdating ? await updateProducts(id, data) : await createProducts(data)

      if (res.data.status === 200) {
        swal('Success', res.data.message, 'success')
        history.push('/products')
      } else if (res.data.status === 400 || res.data.status === 422) {
        // Validation errors
        setProductList((prev) => ({
          ...prev,
          error_list: res.data.errors || {},
        }))
      }
    } catch (error) {
      swal('Error', 'An error occurred', 'error')
    }
  }

  // Show loader while data is fetched
  if (loading) {
    return <Preloader />
  }

  // Dynamic text for UI
  const pageTitle = 'Products'
  const actionLabel = isUpdating ? 'Update' : 'Add'

  // Breadcrumb/heading data
  const breadcrumb = [
    {
      title: pageTitle,
      name: `${actionLabel} ${pageTitle}`,
      subtitle: actionLabel,
      subtitleroute: '/products',
    },
  ]

  const cardValues = [
    {
      title: pageTitle,
      addorupdate: actionLabel,
    },
  ]

  return (
    <div>
      <BreadCrumb data={breadcrumb} />
      <div className="content">
        <div className="card card-primary">
          <Card data={cardValues}>
            <form onSubmit={submitForm}>
              <div className="row">
                {/* Product Code */}
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="pb-2">
                      Product Code <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="product_code"
                      value={productList.product_code}
                      onChange={handleInput}
                      placeholder="Product Code"
                    />
                    <span className="text-danger">{productList?.error_list?.product_code}</span>
                  </div>
                </div>

                {/* Product Name */}
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="pb-2">
                      Product Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="product_name"
                      value={productList.product_name}
                      onChange={handleInput}
                      placeholder="Product Name"
                    />
                    <span className="text-danger">{productList?.error_list?.product_name}</span>
                  </div>
                </div>

                {/* "Customer Product" Checkbox */}
                <div className="col-lg-6 mt-2">
                  <div className="form-check w-100">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="is_customer_product"
                      id="is_customer_product"
                      checked={productList.is_customer_product === 1}
                      onChange={handleCheckbox}
                    />
                    <label className="form-check-label" htmlFor="is_customer_product">
                      Customer supplied product
                    </label>
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary mt-3">
                {actionLabel}
              </button>
            </form>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default CreateOrUpdate
